function formatarMoeda(valor) {
  if (isNaN(valor) || valor === null || valor === undefined) {
    return 'R$ 0,00';
  }
  const valorFormatado = parseFloat(valor).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
  return valorFormatado;
}

function formatarMoeda4Casas(valor) {
  if (isNaN(valor)) {
    return 'R$ 0,0000';
  }

  const valorFormatado = parseFloat(valor).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  });

  return valorFormatado;
}

function formatarMoedaSemCifrao(valor) {
  if (isNaN(valor)) {
    return '0,00';
  }
  // Converte o número para formato de moeda brasileira
  const numeroFormatado = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);

  // Remove o símbolo do real (R$)
  const numeroSemSimbolo = numeroFormatado.replace('R$', '').trim();

  return numeroSemSimbolo;
}


function formatCurrency(value) {
    // Garante string e remove tudo que não é dígito
    const onlyDigits = String(value).replace(/\D/g, "");

    if (!onlyDigits) return (0.00).toFixed(2);

    // Converte para número inteiro (centavos)
    const intValue = parseInt(onlyDigits, 10);

    // Divide por 100 e arredonda para 2 casas decimais
    return (Math.round((intValue / 100) * 100) / 100).toFixed(2);
}


export { formatarMoeda, formatarMoedaSemCifrao, formatCurrency, formatarMoeda4Casas };
